import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGlobe } from "@fortawesome/free-solid-svg-icons";

const IconLanguage = ({ ...props }) => {
  return <FontAwesomeIcon icon={faGlobe} color="#6B98AD" {...props} />;
};

export default IconLanguage;
